// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemList_container__1kXbi","header":"ItemList_header__3Ppkl"};